import React from 'react';

import AccountCardConfigurator from '../../services/cards/views/AccountCardConfigurator';

const CardsDevView = () => {
  return (
    <div className="cards-dev-view">
      <AccountCardConfigurator />
    </div>
  );
};

export default CardsDevView;
